// extracted by mini-css-extract-plugin
export var wrap = "TableOfContents-module--wrap--1nH3I";
export var title = "TableOfContents-module--title--Q2kvm";
export var item = "TableOfContents-module--item--dqqe0";
export var list = "TableOfContents-module--list--3su1O";
export var current = "TableOfContents-module--current--3M7Mv";
export var card = "TableOfContents-module--card--308Gy";